@if (activeLayout() === 'default') {
  <div class="relative flex min-w-0 flex-1">
    <app-default-layout />
  </div>
} @else if (activeLayout() === 'empty') {
  <div class="relative flex min-w-0 flex-1">
    <app-empty-layout />
  </div>
} @else {
  <div class="relative flex min-w-0 flex-1">
    <app-default-layout />
  </div>
}
